<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="user-header container">
      <div class="photo-and-data">
        <div class="photo" :style="{'background-image': 'url(\'assets/img/'+user.photo+'\')'}">
          <div class="icon student">
            <i class="fa fa-envelope-o"></i>
          </div>
        </div>
        <div class="data">
          <div class="block bottom">
            <div class="name">
              {{ user.name }}
            </div>
            <div class="birthdate">
              ({{ user.birthdate }})
            </div>
          </div>
          <div class="block center">
            <div class="user-type student">
              {{ user.type }}
            </div>
            <div class="evaluation-wrapper">
              <div class="bar-wrapper">
                <div class="bar-bg">
                  <div class="bar" :style="{'background-color':user.bar_color, width: user.evaulation+'%'}">

                  </div>
                </div>
                <div class="text">
                  {{ user.evaulation }}%
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="address">
              <div class="title">
                Elérhetőségek
              </div>
              <ul>
                <li><i class="fa fa-map-marker"></i>{{ user.address }}</li>
                <li><i class="fa fa-phone"></i>{{ user.phone }}</li>
                <li><i class="fa fa-envelope-o"></i><a :href="'mailto:' + user.email">{{ user.email }}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <div class="social">
          <a href="#" class="gp"><i class="fa fa-google-plus"></i></a>
          <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
          <a href="#" class="fb"><i class="fa fa-facebook"></i></a>
        </div>
        <button type="button" class="button v2">Üzenet küldése</button>
      </div>
    </div>
    <div class="user-header-info">
      <div class="container">
        <div class="metadata">
          <div class="col">
            <div class="value">
              {{ user.publications.amount }}
            </div>
            <div class="field">
              Publikáció
            </div>
          </div>
          <div class="col">
            <div class="value">
              {{ user.watched }}
            </div>
            <div class="field">
              Megtekintés
            </div>
          </div>
          <div class="col">
            <div class="value">
              {{ user.languages.amount }}
            </div>
            <div class="field">
              Nyelvismeret
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="submenu clearfix">
      <div class="container">
        <ul>
          <li :class="{active: subpage == 'main'}">
            <a v-on:click="() => { subpage = 'main'}" href="javascript:void(0)">Összesítő</a>
          </li>
          <li :class="{active: subpage == 'publications'}">
            <a v-on:click="() => { subpage = 'publications'}" href="javascript:void(0)">Publikációk</a>
          </li>
        </ul>
      </div>
    </div>

    <mainPage v-if="subpage == 'main' && user != ''" :user="user" :changeSubPage="changeSubPage" :changePublicationID="changePublicationID" />
    <comments v-if="subpage == 'comments'" :user="user" :changeSubPage="changeSubPage" />
    <publications v-if="subpage == 'publications' && publication_id == 0" :user="user" :changeSubPage="changeSubPage" :changePublicationID="changePublicationID" />
    <publication v-if="subpage == 'publications' && publication_id != 0" :user="user" :changeSubPage="changeSubPage" :publication_id="publication_id" />

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      user: '',
      subpage: 'main',
      publication_id: 0
    }
  },
  watch: {
    subpage: function() {
      $(document).scrollTop(0);
    }
  },
  beforeMount: function() {

  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $('.autogrow').autogrow();
      $(window).scrollTop(0);

      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.users.map(function(user, i) {
      if (user.id == _this.$route.query.id) {
        _this.user = user;
      }
    });

  },
  methods: {
    changeSubPage: function(page) {
      this.subpage = page;

      if (page == 'main' || page == 'publications')
        this.publication_id = 0;
    },
    changePublicationID: function(id) {
      this.publication_id = id;
      this.subpage = 'publications';
    }
  }
}

Vue.component('mainPage', {
  props: ['user', 'changeSubPage', 'changePublicationID'],
  data: function() {
    return {
      name: '',
      subject: '',
      msg: '',
      errors: [],
      msg_sent: false,
      hasEvaulation: false,
      evaulation_msg: ''
    };
  },
  template: `
    <section>
      <div class="container">
        <router-link class="back-button" :to="{path: '/search'}"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</router-link>
        <div class="row">
          <div class="col-md-6">
            <h5>Statisztika</h5>
            <div class="user-statistics">
              <div class="user-statistic">
                <div class="diagram">
                  <svg class="chart">
                    <circle style="stroke-dasharray: 133 360; stroke: #fad46b;" r="60" cx="60" cy="60"/>
                  </svg>
                  <div class="value-bg">

                  </div>
                  <div class="value">
                  {{ user.languages.amount }}
                  </div>
                </div>
                <div class="text">
                  <div class="title">
                    Nyelvismeret
                  </div>
                  <p v-for="(item, i) in user.languages.items">{{item}}</p>
                </div>
              </div>
              <div class="user-statistic">
                <div class="diagram">
                  <svg class="chart">
                    <circle style="stroke-dasharray: 310 360; stroke: #3eb5ac;" r="60" cx="60" cy="60"/>
                  </svg>
                  <div class="value-bg">

                  </div>
                  <div class="value">
                    {{ user.publications.amount }}
                  </div>
                </div>
                <div class="text">
                  <div class="title">
                    Publikációk
                  </div>
                  <p v-for="(item, i) in user.publications.items">{{item.name}}</p>
                </div>
              </div>
              <div class="user-statistic">
                <div class="diagram">
                  <svg class="chart">
                    <circle :style="{stroke: user.bar_color, 'stroke-dasharray': ((360 * (user.evaulate_point / 5)))+' 360'}" r="60" cx="60" cy="60"/>
                  </svg>
                  <div class="value-bg">

                  </div>
                  <div class="value">
                  {{ user.evaulation }}<span>%</span>
                  </div>
                </div>
                <div class="text">
                  <div class="title">
                    Értékelése
                  </div>
                  <p>{{ user.evaulate_point }} pont az 5-ből</p>
                </div>
              </div>
            </div>
            <h5>Előrehaladás (megszerzett kreditek)</h5>
            <div class="user-statistics">
              <div class="user-statistic">
                <div class="diagram">
                  <svg class="chart">
                    <circle :style="{stroke: '#3eb5ac', 'stroke-dasharray': ((360 * (user.evaulate_point / 1)))+' 360'}" r="60" cx="60" cy="60"/>
                  </svg>
                  <div class="value-bg">

                  </div>
                  <div class="value">
                    100%
                  </div>
                </div>
                <div class="text">
                  <div style="font-size: 13px" class="title">
                    Mérnök Informatikus<br/>BSc
                  </div>
                </div>
              </div>
              <div class="user-statistic">
                <div class="diagram">
                  <svg class="chart">
                    <circle :style="{stroke: '#fad46b', 'stroke-dasharray': ((360 * (4 / 5)))+' 360'}" r="60" cx="60" cy="60"/>
                  </svg>
                  <div class="value-bg">

                  </div>
                  <div class="value">
                    85%
                  </div>
                </div>
                <div class="text">
                  <div style="font-size: 13px" class="title">
                    Mérnökinformatikus<br/>MSc
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h5>Életrajz információk</h5>
              <div class="user-cv">
                {{ user.publications.items[0].lead }}
              </div>
            <div class="separator-line"></div>
            <h5>Legújabb publikáció</h5>
            <div class="publication-item">
              <a v-on:click="changePublicationID(user.publications.items[0].id)" href="javascript:void(0)" class="title">
              {{ user.publications.items[0].name }}
              </a>
              <div class="metadata">
                <div class="item date">
                  <i class="fa fa-clock-o"></i>{{ user.publications.items[0].date }}
                </div>
                <div class="evaluation-wrapper">
                  <div class="bar-wrapper">
                    <div class="bar-bg">
                      <div class="bar" :style="{'background-color':user.publications.items[0].bar_color, width: user.publications.items[0].evaulation+'%'}">

                      </div>
                    </div>
                    <div class="text">
                    {{ user.publications.items[0].evaulation }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="lead">
                {{ user.publications.items[0].lead }}
              </div>
              <a v-on:click="changePublicationID(user.publications.items[0].id)" class="button v2">Bővebben</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="separator-line">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5>Legújabb vélemény</h5>
            <div class="comment-item">
              <div class="photo" :style="commentPhoto"></div>
              <div class="data">
                <div class="meta">
                  <div class="name">
                    <div>
                      {{ user.comments[0].name }}
                    </div>
                    <div class="date">
                      {{ user.comments[0].date }}
                    </div>
                  </div>
                  <div :class="user.comments[0].usertype_class" class="user-type student">
                    {{ user.comments[0].usertype }}
                  </div>
                </div>
                <div class="text">
                  {{ user.comments[0].text }}
                </div>
                <div class="clearfix">
                  <a href="javascript:void(0)" v-on:click="changeSubPage('comments')" class="button v2">További vélemények</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h5>Kapcsolat</h5>
            <div class="user-contact-data">
              <div class="block">
                <i class="fa fa-map-marker"></i>
                <p>{{ user.address }}</p>
              </div>
              <div class="block dark">
                <i class="fa fa-phone"></i>
                <p>{{ user.phone }}</p>
              </div>
              <div class="block">
                <i class="fa fa-envelope-o"></i>
                <p><a :href="'mailto:' + user.email">{{ user.email }}</a></p>
              </div>
            </div>

            <h5>Üzenetküldés</h5>
            <form v-if="!this.msg_sent">
              <inputbox id="name" label="Az Ön neve" :errors="errors" name="name" v-model="name"></inputbox>
              <inputbox id="subject" label="Tárgy" :errors="errors" name="subject" v-model="subject"></inputbox>
              <textareabox id="msg" label="Üzenet" :errors="errors" name="msg" v-model="msg"></textareabox>
              <div class="form-group">
                <button v-on:click="sendMessage" type="button" class="button">Üzenet elküldése</button>
              </div>
            </form>
            <div v-if="this.msg_sent" class="info-box success"><span class="highlight" style="display:block; margin-bottom: 15px;">Sikeres üzenetküldés!</span> Üzenetét sikeresen továbbítottuk a címzett felé.<br><br>Üdvözlettel,<br>Utánpótlás támogató rendszer</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="separator-line">

            </div>
            <h5>Felhasználó értékelése, vélemény</h5>
            <div v-if="!this.hasEvaulation" class="new-evaluation">
              <evaulationDrag label="Felhasználó értékelése" v-on:changePoint="abc"/>
              <textareabox id="msg" label="Üzenet" name="msg" v-model="evaulation_msg" placeholder="Írja le véleményét..."></textareabox>
              <div class="form-group">
                <button v-on:click="newEvaulateClick" type="button" class="button v2">Értékelés</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.hasEvaulation" class="info-box warning">
          <span class="highlight">Sikeres értékelés.</span> Köszönjük hogy értékelte és véleményezte a felhasználót.
        </div>

      </div>
    </section>
  `,
  computed: {
    commentPhoto: function() {
      return {
        'background-image': "url('assets/img/"+this.user.comments[0].photo+"')"
      }
    }
  },
  mounted: function() {
  },
  methods: {
    abc: function(value) {
        console.log(value);
    },
    newEvaulateClick: function() {
      this.hasEvaulation = true;
      this.user.comments.unshift(
        {
          name: 'Teszt Felhasználó',
          photo: 'profile.png',
          date: '2018.02.12.',
          usertype: 'Hallgató',
          usertype_class: 'student',
          text: this.evaulation_msg
        }
      );
    },
    sendMessage: function() {
      this.errors = [];

      if (this.name == '')
        this.errors.push({id: 'name', msg:'Kötelező'});

      if (this.subject == '')
        this.errors.push({id: 'subject', msg:'Kötelező'});

      if (this.msg == '')
        this.errors.push({id: 'msg', msg:'Kötelező'});

        if (this.errors.length > 0)
          return false;

        this.msg_sent = true;
    }
  }
});

Vue.component('comments', {
  props: ['user', 'changeSubPage'],
  data: function() {
    return {
      hasEvaulation: false,
      msg: ''
    };
  },
  template: `
    <section>
      <div class="container">
        <a v-on:click="changeSubPage('main')" href="javascript:void(0)" class="back-button"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</a>
        <h5>Vélemények</h5>

        <div class="comment-items">
          <div v-for="(comment, i) in user.comments" class="comment-item wide">
            <div class="photo" :style="photoStyle(comment.photo)"></div>
            <div class="data">
              <div class="meta">
                <div class="name">
                  <div>
                    {{ comment.name }}
                  </div>
                  <div class="date">
                    {{ comment.date }}
                  </div>
                </div>
                <div class="user-type student" :class="comment.usertype_class">
                  {{ comment.usertype }}
                </div>
              </div>
              <div v-html="nl2br(comment.text)" class="text">
              </div>
            </div>
          </div>
        </div>

        <div class="separator-line"></div>

        <h5>Felhasználó értékelése, vélemény</h5>
        <div v-if="this.hasEvaulation" class="info-box warning">
          <span class="highlight">Sikeres értékelés.</span> Köszönjük hogy értékelte és véleményezte a felhasználót.
        </div>
        <div v-if="!this.hasEvaulation" class="new-evaluation">
          <evaulationDrag label="Felhasználó értékelése"/>
          <textareabox id="msg" label="Üzenet" name="msg" v-model="msg" placeholder="Írja le véleményét..."></textareabox>
          <div class="form-group">
            <button v-on:click="newEvaulateClick" type="button" class="button v2">Értékelés</button>
          </div>
        </div>

      </div>
    </section>
  `,
  computed: {

  },
  mounted: function() {
  },
  methods: {
    nl2br: function(str, is_xhtml) {
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    photoStyle: function(photo) {
      return {
        'background-image': "url('assets/img/"+photo+"')"
      }
    },
    newEvaulateClick: function() {
      this.hasEvaulation = true;
      this.user.comments.unshift(
        {
          name: 'Teszt Felhasználó',
          photo: 'profile.png',
          date: '2018.02.12.',
          usertype: 'Hallgató',
          usertype_class: 'student',
          text: this.msg
        }
      );
    },
  }
});

Vue.component('publications', {
  props: ['user', 'changeSubPage', 'changePublicationID'],
  data: function() {
    return {
    };
  },
  template: `
    <section>
      <div class="container">
        <a v-on:click="changeSubPage('main')" href="javascript:void(0)" class="back-button"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</a>
        <h5>Publikációk</h5>
        <div class="publication-items">
            <div class="row">
              <div v-for="(item, i) in user.publications.items">
              <div class="col-md-6">
                <div class="publication-item">
                  <a v-on:click="changePublicationID(item.id)" href="javascript:void(0)" class="title">
                    {{ item.name }}
                  </a>
                  <div class="metadata">
                    <div class="item creator">
                      <i class="fa fa-pencil"></i>{{ item.author }}
                    </div>
                    <div class="item date">
                      <i class="fa fa-clock-o"></i>{{ item.date }}
                    </div>
                    <div class="evaluation-wrapper">
                      <div class="bar-wrapper">
                        <div class="bar-bg">
                          <div class="bar" :style="{'background-color': item.bar_color, width: item.evaulation + '%'}">

                          </div>
                        </div>
                        <div class="text">
                        {{ item.evaulation }}%
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="lead">
                    {{ item.lead }}
                  </div>
                  <div class="publication-download-items">
                    <div v-for="(file, i) in item.files" class="publication-download-item">
                      <div class="text">
                        <i class="fa fa-file-text-o"></i>{{ file }}
                      </div>
                      <a href="javascript:void(0)" class="icon">
                        <i class="fa fa-download"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="(i + 1) % 2 == 0 && i != 0" class="clearfix hide visible-lg visible-md"></div>
              </div>
            </div>
        </div>
        <div class="breadcrumbs clearfix">
          <ul>
            <li class="prev"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
            <li><a href="">1</a></li>
            <li><a href="">2</a></li>
            <li class="active"><a href="">3</a></li>
            <li><a href="">4</a></li>
            <li><a href="">5</a></li>
            <li><a href="">6</a></li>
            <li><a href="">7</a></li>
            <li class="next"><a href=""><img src="assets/img/arrow.png" alt=""/></a></li>
          </ul>
          <div class="result">
            Összesen <span>20</span> találat <span>3</span> oldalon.
          </div>
        </div>

      </div>
    </section>
  `,
  computed: {

  },
  mounted: function() {
  },
  methods: {
  }
});

Vue.component('publication', {
  props: ['user', 'changeSubPage', 'publication_id'],
  data: function() {
    return {
      publication: '',
      evaulation_msg: '',
      hasEvaulation: false
    };
  },
  template: `
    <section>
      <div class="container">
        <a v-on:click="changeSubPage('publications')" href="javascript:void(0)" class="back-button"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</a>
        <h5>Publikáció</h5>
        <div class="publication-item detail">
          <div class="title">
          {{ publication.name }}
          </div>
          <div class="metadata">
            <div class="item creator">
              <i class="fa fa-pencil"></i>{{ publication.author }}
            </div>
            <div class="item date">
              <i class="fa fa-clock-o"></i>{{ publication.date }}
            </div>
            <div class="evaluation-wrapper">
              <div class="bar-wrapper">
                <div class="bar-bg">
                  <div class="bar" :style="{'background-color':publication.bar_color, width: publication.evaulation+'%'}">

                  </div>
                </div>
                <div class="text">
                  {{ publication.evaulation }}%
                </div>
              </div>
            </div>
          </div>
          <div class="lead">
          {{ publication.lead }}
          </div>
        </div>

        <div class="separator-line"></div>

        <h5>Kapcsolódó fájlok</h5>
        <div v-for="(file, i) in publication.files" class="publication-download-item">
          <div class="text">
            <i class="fa fa-file-text-o"></i>{{ file }}
          </div>
          <a href="javascript:void(0)" class="icon">
            <i class="fa fa-download"></i>
          </a>
        </div>

        <div class="separator-line"></div>

        <h5>Vélemények</h5>
        <div v-if="publication.comments != undefined && publication.comments.length > 0" class="comment-items">
          <div v-for="(comment, i) in publication.comments"  class="comment-item wide">
            <div class="photo" :style="commentPhoto(comment.photo)"></div>
            <div class="data">
              <div class="meta">
                <div class="name">
                  <div>
                    {{ comment.name }}
                  </div>
                  <div class="date">
                    {{ comment.date }}
                  </div>
                </div>
                <div :class="comment.usertype_class" class="user-type">
                  {{ comment.usertype }}
                </div>
              </div>
              <div class="text">
                {{ comment.text }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="publication.comments == undefined || this.publication.comments.length == 0" class="info-box warning">
          Még nem írt senki véleményt a publikációról.
        </div>


        <div class="separator-line"></div>

        <h5>Publikáció értékelése, vélemény</h5>
        <div v-if="!this.hasEvaulation" class="new-evaluation">
          <evaulationDrag label="A publikáció értékelése"/>
          <textareabox id="msg" label="Üzenet" name="msg" v-model="evaulation_msg" placeholder="Írja le véleményét..."></textareabox>
          <div class="form-group">
            <button v-on:click="newEvaulateClick" type="button" class="button v2">Értékelés</button>
          </div>
        </div>
        <div v-if="this.hasEvaulation" class="info-box warning">
          <span class="highlight">Sikeres értékelés.</span> Köszönjük hogy értékelte és véleményezte a publikációt.
        </div>

      </div>
    </section>
  `,
  computed: {
  },
  mounted: function() {
    var _this = this;

    this.user.publications.items.map(function(publication, i) {
      if (publication.id == _this.publication_id)
        _this.publication = publication;
    });
  },
  methods: {
    commentPhoto: function(photo) {
      return {
        'background-image': "url('assets/img/"+photo+"')"
      }
    },
    newEvaulateClick: function() {
      this.hasEvaulation = true;
      this.publication.comments.unshift(
        {
          name: 'Teszt Felhasználó',
          photo: 'profile.png',
          date: '2018.02.12.',
          usertype: 'Hallgató',
          usertype_class: 'student',
          text: this.evaulation_msg
        }
      );
    },
  }
});
</script>




// WEBPACK FOOTER //
// userpage.vue?3fa5b2bf